import { useContext, useState } from 'react';
import Dialog from '@/components/Dialog';
import DeleteButton from '../PortfolioTemplatesEditorActionButtons/DeleteButton';
import { FormattedMessage } from 'react-intl';
import useApi from '@/lib/api/useApi';
import { type EditorTopic } from '@/lib/types';
import EditorPortfolioTemplatesContext from '../../EditorPortfolioTemplatesContext';

type DeleteTopicProps = {
  topic: EditorTopic;
};

const DeleteTopic = ({ topic }: DeleteTopicProps) => {
  const api = useApi();

  const [, setPortfolioTemplates] = useContext(EditorPortfolioTemplatesContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteTopic = async (): Promise<void> => {
    setConfirmationDialogOpen(false);
    setDeleting(true);

    await api.delete(`editor/portfolio-templates/topics/${topic.id}`);

    setPortfolioTemplates(portfolioTemplates => {
      delete portfolioTemplates.topics[topic.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <DeleteButton
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      />
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio_template_editor.topic.delete.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio_template_editor.topic.delete.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteTopic} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteTopic;
